import { render } from "./StatsTable.vue?vue&type=template&id=68ec04ac"
import script from "./StatsTable.vue?vue&type=script&lang=js"
export * from "./StatsTable.vue?vue&type=script&lang=js"

import "./StatsTable.vue?vue&type=style&index=0&id=68ec04ac&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__